var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 6,
    fill: "#CFECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 33.4225C36.7551 33.4225 38.1778 31.9997 38.1778 30.2447C38.1778 28.4896 36.7551 27.0669 35 27.0669C33.245 27.0669 31.8223 28.4896 31.8223 30.2447C31.8223 31.9997 33.245 33.4225 35 33.4225Z",
    fill: "#14A2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9668 21.7888C44.2707 21.7896 42.6014 21.3656 41.1112 20.5555L35.0001 17.2222L28.889 20.5555C27.3989 21.3656 25.7296 21.7896 24.0335 21.7888H19.5112V35.8888C19.5122 38.8053 20.3502 41.6601 21.9259 44.1143C23.5016 46.5684 25.7487 48.5186 28.4001 49.7333L35.0001 52.7777L41.6112 49.7444C44.2627 48.5297 46.5097 46.5795 48.0854 44.1254C49.6611 41.6712 50.4992 38.8164 50.5001 35.8999V21.7888H45.9668ZM35.0001 24.5222C36.1297 24.5222 37.2339 24.8571 38.173 25.4847C39.1122 26.1122 39.8442 27.0042 40.2765 28.0477C40.7088 29.0913 40.8219 30.2396 40.6015 31.3475C40.3811 32.4553 39.8372 33.4729 39.0385 34.2716C38.2398 35.0704 37.2221 35.6143 36.1143 35.8347C35.0065 36.055 33.8581 35.9419 32.8146 35.5097C31.771 35.0774 30.8791 34.3454 30.2515 33.4062C29.624 32.467 29.289 31.3628 29.289 30.2333C29.2919 28.7195 29.8946 27.2686 30.965 26.1982C32.0354 25.1278 33.4863 24.5251 35.0001 24.5222ZM40.0779 42.9333C40.0779 42.2585 39.8098 41.6113 39.3326 41.1341C38.8555 40.6569 38.2083 40.3888 37.5335 40.3888H32.4557C32.123 40.3888 31.7936 40.4544 31.4862 40.5817C31.1789 40.709 30.8996 40.8956 30.6643 41.1308C30.4291 41.3661 30.2425 41.6453 30.1152 41.9527C29.9879 42.2601 29.9223 42.5895 29.9223 42.9222H27.3779C27.3779 41.5755 27.9129 40.2839 28.8651 39.3316C29.8174 38.3794 31.109 37.8444 32.4557 37.8444H37.5335C38.8793 37.8473 40.1691 38.3832 41.1207 39.3349C42.0724 40.2865 42.6083 41.5764 42.6112 42.9222L40.0779 42.9333Z",
    fill: "#14A2FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAdmin);
export default __webpack_public_path__ + "static/media/BankAdmin.f7dc94b09b0f9c2be7fa6f4eb9ec387c.svg";
export { ForwardRef as ReactComponent };